"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  FIRST_MAJOR: 'firstMajor',
  OTHER_FIRST_MAJOR: 'otherFirstMajor',
  SECOND_MAJOR: 'secondMajor',
  OTHER_SECOND_MAJOR: 'otherSecondMajor',
  THIRD_MAJOR: 'thirdMajor',
  OTHER_THIRD_MAJOR: 'otherThirdMajor',
  UNDECIDED_MAJOR: 'Undecided',
  INTENDED_MAJOR: 'Intended'
};
exports.default = _default;